import { useTranslation } from "react-i18next";
import { initI18n } from "./i18n";
import { WorkflowAutomation } from "./interface";
import { useCallback, useEffect, useState } from "react";
import { useRive } from "@rive-app/react-canvas-lite";

initI18n();

interface Props {
  token: string;
  initialAutomation?: WorkflowAutomation;
  onCompleteAutomation: (automation: WorkflowAutomation) => void;
  selectedWorkflow: string;
}

function AppOnboardingGenerating(props: Props) {
  const { token, initialAutomation, onCompleteAutomation } = props;
  const { t } = useTranslation();

  const [currentAutomation, setCurrentAutomation] = useState<WorkflowAutomation>();

  const { RiveComponent } = useRive({
    src: `https://static.portant.co/hs-onboarding-${props.selectedWorkflow}.riv`,
    autoplay: true
  });

  const fetchAutomation = useCallback(() => {
    if (!initialAutomation)
      return;

    fetch(`${process.env.REACT_APP_API_ENDPOINT}/hubspot/onboarding/automations/${initialAutomation?.id}/`, {
      headers: { "X-Token": token! },
    })
      .then(res => res.json())
      .then(setCurrentAutomation)
      .catch(error => {
        console.error('Error fetching automation:', error);
      });
  }, [initialAutomation, token])

  useEffect(() => {
    if (currentAutomation && !["PENDING", "RUNNING"].includes(currentAutomation.status))
      onCompleteAutomation(currentAutomation);
  }, [currentAutomation, onCompleteAutomation]);

  useEffect(() => {
    fetchAutomation();
    const interval = setInterval(fetchAutomation, 2000);

    return () => clearInterval(interval);
  }, [fetchAutomation, onCompleteAutomation]);

  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col items-center">
        <div className="font-gilroy font-semibold text-gray-600 text-3xl">{t("Say goodbye to manual paperwork!")}</div>
        <div className="font-semibold text-sm text-gray-400">{t("Let's reclaim hours of your time, reduce manual work, and boost sales month on month.")}</div>
      </div>
      <div className="flex justify-center">
        <RiveComponent className="w-[600px] h-[300px]" />
      </div>
      <div className="text-sm font-semibold text-gray-400 text-center">{t("Processing... your document will be ready in a few seconds...")}</div>
    </div>
  );
}

export default AppOnboardingGenerating;
